import Directives from '@/views/directives/directives.view.vue';

export default [
  {
    path: '/:projectName/directives',
    name: 'directives',
    component: Directives,
  },
];
